import { render, staticRenderFns } from "./LiquidacionCodigos.vue?vue&type=template&id=dd88889e"
import script from "./LiquidacionCodigos.vue?vue&type=script&lang=js"
export * from "./LiquidacionCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports